import FormSpacer from "@saleor/components/FormSpacer";
import SingleAutocompleteSelectField, {
  SingleAutocompleteChoiceType
} from "@saleor/components/SingleAutocompleteSelectField";
import { StaffErrorFragment } from "@saleor/fragments/types/StaffErrorFragment";
import { FormChange } from "@saleor/hooks/useForm";
import { maybe } from "@saleor/misc";
import { FetchMoreProps } from "@saleor/types";
import { getFormErrors } from "@saleor/utils/errors";
import getStaffErrorMessage from "@saleor/utils/errors/staff";
import React from "react";
import { useIntl } from "react-intl";
interface StaffDetailsFormProps {
  formData: {
    mallId: string | null;
    tenantId: string | null;
    brandId: string | null;
  };
  disabled: boolean;
  errors: StaffErrorFragment[];
  handleChange: FormChange;
  mallChange: FormChange;
  brandChange: FormChange;
  tenantChange: FormChange;
  showBrands: boolean;
  showMalls: boolean;
  showTenants: boolean;
  mallChoices: SingleAutocompleteChoiceType[];
  brandChoices: SingleAutocompleteChoiceType[];
  tenantChoices: SingleAutocompleteChoiceType[];
  mallDisplayValue: string;
  brandDisplayValue: string;
  tenantDisplayValue: string;
  fetchMalls: (query: string) => void;
  fetchBrands: (query: string) => void;
  fetchTenants: (query: string) => void;
  fetchMoreMalls: FetchMoreProps;
  fetchMoreBrands: FetchMoreProps;
  fetchMoreTenants: FetchMoreProps;
}

export const StaffAssignmentDropdowns: React.FC<StaffDetailsFormProps> = ({
  errors,
  handleChange,
  mallChange,
  brandChange,
  tenantChange,
  showBrands,
  showMalls,
  showTenants,
  formData,
  mallChoices,
  brandChoices,
  tenantChoices,
  mallDisplayValue,
  brandDisplayValue,
  tenantDisplayValue,
  fetchMalls,
  fetchBrands,
  fetchTenants,
  fetchMoreMalls,
  fetchMoreBrands,
  fetchMoreTenants
}) => {
  const intl = useIntl();

  const formFields = ["mallId", "brandId", "tenantId"];
  const formErrors = getFormErrors(formFields, errors);
  return (
    <div>
      {showMalls ? (
        <>
          <FormSpacer />
          <SingleAutocompleteSelectField
            idInputTxt="mallTxt"
            error={!!formErrors.mallId}
            helperText={getStaffErrorMessage(formErrors.mallId, intl)}
            choices={maybe(() => mallChoices, [])}
            displayValue={mallDisplayValue}
            label={intl.formatMessage({ defaultMessage: "Mall" })}
            name="mallId"
            value={formData.mallId}
            onChange={event => {
              handleChange(event);
              mallChange(event);
            }}
            fetchChoices={fetchMalls}
            {...fetchMoreMalls}
          />
        </>
      ) : null}
      {showBrands ? (
        <>
          <FormSpacer />
          <SingleAutocompleteSelectField
            idInputTxt="tradeNameTxt"
            error={!!formErrors.brandId}
            helperText={getStaffErrorMessage(formErrors.brandId, intl)}
            choices={maybe(() => brandChoices, [])}
            displayValue={brandDisplayValue}
            label={intl.formatMessage({ defaultMessage: "Trade Name" })}
            name="brandId"
            value={formData.brandId}
            onChange={event => {
              handleChange(event);
              brandChange(event);
            }}
            fetchChoices={fetchBrands}
            {...fetchMoreBrands}
          />
        </>
      ) : null}
      {showTenants ? (
        <>
          <FormSpacer />
          <SingleAutocompleteSelectField
            idInputTxt="storeTxt"
            error={!!formErrors.tenantId}
            helperText={getStaffErrorMessage(formErrors.tenantId, intl)}
            choices={maybe(() => tenantChoices, [])}
            displayValue={tenantDisplayValue}
            label={intl.formatMessage({ defaultMessage: "Store" })}
            name="tenantId"
            value={formData.tenantId}
            onChange={event => {
              handleChange(event);
              tenantChange(event);
            }}
            fetchChoices={fetchTenants}
            {...fetchMoreTenants}
          />
        </>
      ) : null}
    </div>
  );
};

export default StaffAssignmentDropdowns;
